import { useContext } from "react";
import { ConfigContext } from "../providers/config";

const useConfig = () => {
  const values = useContext(ConfigContext);
  return values;
};

export default useConfig;
